import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center loader-container"
}
const _hoisted_2 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loader-wrapper", {active: _ctx.visible}])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.visible)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[0] || (_cache[0] = [
                _createElementVNode("path", {
                  d: "M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z",
                  class: "loader-icon"
                }, null, -1)
              ])))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}